<div class="otp-container">
  <router-outlet></router-outlet>
</div>
